"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const styles = {
    Absolute: {
        'top-right': (0, app_1.css) `
      top: 0;
      right: 0;
    `,
        'top-left': (0, app_1.css) `
      top: 0;
      right: 100%;
    `,
        'bottom-left': (0, app_1.css) `
      top: 100%;
      right: 100%;
    `,
        'bottom-right': (0, app_1.css) `
      top: 100%;
      right: 0;
    `,
    },
};
const Relative = app_1.styled.div `
  position: relative;
  display: inline-block;
`;
const Absolute = app_1.styled.div `
  position: absolute;
  ${(_, { $position }) => styles.Absolute[$position]}
  transform: translate(50%, -50%);
  transform-origin: 100% 0%;
`;
const BadgeComp = app_1.styled.div `
  --badge-size: 1.375rem;
  border-radius: calc(var(--badge-size) / 2);
  background: ${(theme) => theme.colors.primary};
  border: 0.1875em solid;
  height: var(--badge-size);
  min-width: var(--badge-size);
  font-size: 0.75em;
  font-weight: bold;
  padding: calc(var(--badge-size) / 5);
  line-height: 1rem;
  ${(theme) => theme.flexCenter};
  display: ${(_, { $hidden }) => ($hidden ? 'none' : 'flex')};
  color: ${(theme) => theme.colors.primary.intense};
`;
function Badge({ children, count, position = 'top-right', overflow, displayEmpty, className, }) {
    const countToDisplay = overflow && count > overflow ? `${overflow}+` : String(count);
    const visible = count !== 0 || displayEmpty;
    return ((0, jsx_runtime_1.jsxs)(Relative, { children: [children, (0, jsx_runtime_1.jsx)(Absolute, Object.assign({ "$position": position }, { children: (0, jsx_runtime_1.jsx)(BadgeComp, Object.assign({ className: className, "$hidden": !visible }, { children: countToDisplay })) }))] }));
}
exports.Badge = Badge;
